/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

{/* <button id="swymcs-wishlist-button" class="swymcs-wishlist-button swymcs-wishlist-button-8277305557170 " data-empi="8277305557170" data-epi="44657578279090" data-du="https://lovetodream-au.myshopify.com/products/swaddle-up-original-cotton-1-0-tog-deep-olive"></button> */}
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
  
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
	<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button swym-added-custom">
	<span class="swym-icon">
	</span>
	</button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
     </div>
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
       {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
     </button>
   </a>
   {{/products}}
</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

// function onAddToCartClick(e) {
// 	e.preventDefault();
// 	var productId = e.currentTarget.getAttribute("data-product-id");
// 	var variantId = e.currentTarget.getAttribute("data-variant-id");
// 	var du = e.target.getAttribute("data-product-url");
// 	e.target.innerHTML = "Adding..";
// 	window._swat.replayAddToCart({
// 		empi: productId,
// 		du: du
// 	}, variantId, function(c) {
// 		e.target.innerHTML = "Added to Cart";
// 		e.target.setAttribute("data-state-cart", "swym-added");
// 		console.log("Successfully added product to cart.", c);
// 	}, function(e) {
// 		console.log(e);
// 	});
// }

// function onRemoveBtnClick(e) {
// 	console.log('??')
// 	e.preventDefault();
// 	var epi = +e.currentTarget.getAttribute("data-variant-id");
// 	var empi = +e.currentTarget.getAttribute("data-product-id");
// 	window._swat.fetch(function(products) {
// 		products.forEach(function(product) {
// 			if (epi && empi && product.epi == epi && product.empi == empi){
// 				window._swat.removeFromWishList(product, function() {
// 					if (!window.SwymCallbacks) {
// 						window.SwymCallbacks = [];
// 					}
// 					window.SwymCallbacks.push(swymRenderWishlist);
// 				});
// 			}
// 		});
// 	})
// }



function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
}

// if (!window.SwymCallbacks) {
// 	window.SwymCallbacks = [];
// }
// window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

/* Initializes the wishlist functions by fetching the list and adding event listeners. */

const init = (swat) => {

	let lists = fetchList(swat);

	if(!window.swymSelectedListId){
	   createList(swat);
	}
	swymRenderWishlist(swat);


	addSwymEventListener(swat);
  };

  const swymRenderWishlist = (swat) => {

	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.error("Container not found, Wishlist Page element not found");
		}
	});
}
  
  /* Fetches the wishlist data. */
  
  const fetchList = async (swat) => {
	return new Promise((resolve, reject) => {
	  const onSuccess = (lists) => {
		window.swymWishLists = lists;
		window.swymSelectedListId = lists && lists[0] && lists[0].lid;
		resolve(lists);
		updateButtonState();
	  };
  
	  const onError = (error) => {
		console.error("Error while fetching all Lists", error);
		reject(error);
	  };
  
	  if (!window.swymWishLists) {
		swat.fetchLists({
		  callbackFn: onSuccess,
		  errorFn: onError
		});
	  } else {
		resolve(window.swymWishLists);
	  }
	});
  };
  
  /* Create a new wishlist if not already exist. */
  
  const createList = (swat) => {
	
	  let listConfig = { "lname": "My Wishlist" };
	  
	  let onSuccess = function({lid}) { 
		window.swymSelectedListId = lid;
	  }
	  
	  let onError = function(error) {
		console.error("Error while creating a List", error);
	  }
	  
	  swat.createList(listConfig, onSuccess, onError);
  }
  
  /* Refreshes the wishlist by fetching the list again in the global scope. */
  
  const refreshList = async (swat) => {
	window.swymWishLists = null;
	await fetchList(swat);
  };
  
  /* Adds product to wishlist action. */
  const addToWishlist = (swat, product) => {
	  let onSuccess = async function (addedListItem){
		console.log('Product has been added to wishlist!', addedListItem);
	  }
	  
	  let onError = function (error){
		swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
	  }
  
	  let lid = window.swymSelectedListId;
  
	  swat.addToList(lid, product, onSuccess, onError);
  }
  
  /* Remove product from wishlist action. */ 
  const removeFromWishlist = (swat, product) => {
	let onSuccess = async function(deletedProduct) {
	  console.log('Product has been removed from wishlist!', deletedProduct);
	}
	
	let onError = function(error) {
	  swat.ui.showErrorNotification({ message: "Error removing Product from Wishlist" });
	}
  
	let lid = window.swymSelectedListId;
  
	swat.deleteFromList(lid, product, onSuccess, onError);
  }
  
  /* Updates the state of wishlist buttons based on whether items are wishlisted. */
  const updateButtonState = () => {
	// Update PLP buttons (swymcs-wishlist-button)
	const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');
	if (swymWishlistButtons) {
	  swymWishlistButtons.forEach((swymWishlistButton) => {
		const elements = swymWishlistButton.elements;
		const { epi, empi } = elements.wishlistButton.dataset;
		let isWishlisted = false;
  
		if (window.swymWishLists) {
		  window.swymWishLists.forEach(list => {
			list.listcontents.forEach(item => {
			  if (item.empi == empi && item.epi == epi) {
				isWishlisted = true;
			  }
			});
		  });

		  updateButtonWishlistState(elements, isWishlisted);
		}
	  });
	}

	// Update PDP buttons (swym-add-to-wishlist-view-product)
	const pdpWishlistButtons = document.querySelectorAll('button.swym-add-to-wishlist-view-product');
	if (pdpWishlistButtons) {
	  pdpWishlistButtons.forEach((button) => {
		// Parse JSON values from Liquid template (data-product-id uses | json filter)
		const epiRaw = button.getAttribute('data-variant-id');
		const empiRaw = button.getAttribute('data-product-id');
		const epi = epiRaw ? (epiRaw.startsWith('"') ? JSON.parse(epiRaw) : epiRaw) : null;
		const empi = empiRaw ? (empiRaw.startsWith('"') ? JSON.parse(empiRaw) : empiRaw) : null;
		let isWishlisted = false;

		// Check if product is wishlisted (only if swymWishLists is available)
		if (epi && empi && window.swymWishLists) {
		  window.swymWishLists.forEach(list => {
			list.listcontents.forEach(item => {
			  // Compare as strings to handle type coercion
			  if (String(item.empi) === String(empi) && String(item.epi) === String(epi)) {
				isWishlisted = true;
			  }
			});
		  });
		}

		// Update tooltip for PDP buttons (both title and aria-label)
		// Always set initial title, even if swymWishLists hasn't loaded yet
		if (window.wishlistStrings) {
		  if (isWishlisted) {
			button.setAttribute('title', window.wishlistStrings.removeFromWishlist);
			button.setAttribute('aria-label', window.wishlistStrings.removeFromWishlist);
		  } else {
			button.setAttribute('title', window.wishlistStrings.addToWishlist);
			button.setAttribute('aria-label', window.wishlistStrings.addToWishlist);
		  }
		}
	  });
	}
  };
  
  /* Updates the display state of a wishlist button based on whether the item is wishlisted. */
  const updateButtonWishlistState = (elements, isWishlisted) => {
	elements.filledState.style.display = isWishlisted ? 'flex' : 'none';
	elements.unfilledState.style.display = isWishlisted ? 'none' : 'flex';
	if (isWishlisted) {
		elements.wishlistButton.classList.add('swym-added-custom');
		// Update tooltip text for PLP buttons
		if (window.wishlistStrings) {
			elements.wishlistButton.setAttribute('title', window.wishlistStrings.removeFromWishlist);
			elements.wishlistButton.setAttribute('aria-label', window.wishlistStrings.removeFromWishlist);
		}
	} else {
		elements.wishlistButton.classList.remove('swym-added-custom');
		// Update tooltip text for PLP buttons
		if (window.wishlistStrings) {
			elements.wishlistButton.setAttribute('title', window.wishlistStrings.addToWishlist);
			elements.wishlistButton.setAttribute('aria-label', window.wishlistStrings.addToWishlist);
		}
	}
  };
  
  /* Render multiple wishlist popup when multiple wishlist enabled */
  const renderPopup = async(product) => {
	let popup = document.querySelector('swym-wishlist-popup');
	let { epi, empi, du } = product;
	window.currentActiveProduct = await fetchProductsData(du);
	window.currentActiveVariant =  currentActiveProduct.variants.find((variant) => variant.id == epi);
	window.currentActiveVariantId = epi;
	window.currentActiveProduct.url = du;
	setTimeout(popup._show.bind(popup), 100);
  } 
  
  /* Fetches product data from shopify to get updated data. */
  
  const fetchProductsData = async (url) => {
	const productData = await fetch(`${url}.js`);
	if (productData.status === 404 || !productData.ok) return null;
	const jsonData = await productData.json();
	return jsonData;
  };
  
  /* Adds event listeners for wishlist actions. */
  
  const addSwymEventListener = (swat) => {
	swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, (event) => {
	  let image = event.detail.d.iu;
	  let title = event.detail.d.dt;
	  showCustomNotification(swat, image, title, 'remove', 1);
	  refreshList(swat).then(() => {
		updateButtonState();
	  });
	});
	
	swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
	  let image = event.detail.d.iu;
	  let title = event.detail.d.dt;
	  showCustomNotification(swat, image, title, 'add', 1);
	  refreshList(swat).then(() => {
		updateButtonState();
	  });
	});
  
	swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
	  const currentVariant = data.detail.d.variant.id;
	  const currentProductId = data.detail.d.product.id;
	  const swymCustomWishlistButton = document.querySelector(`.swymcs-wishlist-button-${currentProductId}`);
	  if (swymCustomWishlistButton) {
		swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
	  }
	  setTimeout(updateButtonState, 200);
	});
  };
  
  const showCustomNotification = ( swat, image, title, action, listCount ) => {
		let successMessage = `

		<div id="swym-custom-notification-content" onclick="_swat.ui.open()">
			<div id="swym-custom-image-container">
				<img id="swym-custom-image" src="${image}" />
			</div>
			<div id="swym-custom-title-conatainer" style="color: var( --color-brand-teal-dark)"><strong>${title}</strong> has been ${action=='remove'?'removed.':'added.'}</div>
		</div>
	  `;
	//   swat.ui.showSuccessNotification({ message: successMessage });

		const container = document.querySelector(".swym-notification-container");
		const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');
		swymWishlistButtons.forEach((button) => {
			button.querySelector("button").setAttribute("disabled", "true");
			button.querySelector("button").classList.add("disabled");
		})

		container.classList.add("active");
		container.innerHTML = successMessage;

		setTimeout(() => {
			
			container.classList.remove("active");

			swymWishlistButtons.forEach((button) => {
				button.querySelector("button").removeAttribute("disabled");
				button.querySelector("button").classList.remove("disabled");
			})
		}, 2000)
  }
  
  
  /* Creating a global object to assign functions */
  
  const swymcsWishlistFunctions = {
	init,
	swymRenderWishlist,
	fetchList,
	refreshList,
	updateButtonState,
	updateButtonWishlistState,
	addToWishlist,
	removeFromWishlist,
	addSwymEventListener,
	fetchProductsData,
	renderPopup,
	showCustomNotification
  };
  
  /* Push the init functions into SwymCallbacks  */
  
  if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymcsWishlistFunctions.init);
  
  /* Expose swymcsWishlistFunctions to the global scope */
  
  window.swymcsWishlistFunctions = swymcsWishlistFunctions;